{
  "currency-symbol": "$",
  "data-refresh": {
    "availability": {
      "label": "When are you available to start?",
      "now": "Available Now",
      "specific-date": "Available on a Specific Date",
      "specific-date-placeholder": "Availability date",
      "with-notice": "Available with notice",
      "with-notice-placeholder": "Enter the number of weeks notice"
    },
    "check-in": "When can we check in with you again?",
    "employment-type": {
      "label": "Employment Type",
      "temp": "Temporary",
      "temp-to-perm": "Temp-to-perm",
      "perm": "Permanent"
    },
    "error": {
      "required": "{{fieldName}} is a required field",
      "atLeastOne": "At least one option must be selected"
    },
    "header": {
      "text": "WE WOULD LOVE TO BE YOUR CAREER PARTNER",
      "subtext": "If you would like to be considered for current or future opportunities, please take a moment to update your profile information.",
      "subtext-2": "Thanks for taking the time to check in and update your details so that we can help you land brilliant opportunities!",
      "subtext-required": "All fields are required"
    },
    "hourly-rate": {
      "label": "Hourly Rate",
      "target": "Desired",
      "minimum": "Minimum",
      "per-hour":"/hr"
    },
    "hours": {
      "label": "Hours",
      "full-time": "Full Time",
      "part-time": "Part Time"
    },
    "location": "Where are you located?",
    "opportunities": "Are you considering new opportunities?",
    "salary": {
      "label": "Salary",
      "target": "Desired",
      "minimum": "Minimum",
      "per-year": "/yr"
    },
    "submit-go-ahead": {
      "label": "Can we go ahead and submit you to our clients for positions matching your preferences below?",
      "yes": "Yes, go ahead.",
      "no": "No, check with me first."
    },
    "success-page": {
      "heading": "THANK YOU FOR LETTING US KNOW MORE ABOUT YOUR CAREER GOALS!",
      "update-profile-desc": "If you’ve picked up a little more experience since we last heard from you, it’d be great to see an updated CV or portfolio.",
      "find-jobs-desc": "Find more job opportunities on the Aquent job board."
    },
    "workplace": {
      "label": "Workplace",
      "on-site": "On-site",
      "remote": "Remote"
    }
  },
  "eeoc-form" : {
    "age-group": "Age Group",
    "authorized-to-work": "Are you authorized to work in the United States?",
    "contact-us": {
      "text_part1": "Aquent is an equal opportunity employer. We evaluate qualified applicants without regard to race, color, religion, sex, sexual orientation, gender identity, national origin, disability, veteran status, and other legally protected characteristics. Aquent is committed to working with and providing reasonable accommodation to individuals with disabilities. If, because of a medical condition or disability, you need a reasonable accommodation for any part of the employment process, please send an e-mail to ",
      "mailto": "compliance@aquent.com",
      "text_part2": " and let us know the nature of your request and your contact information. The “EEO is the Law” poster is available ",
      "link-text": "here."
    },
    "delete-modal": {
      "title": "UK Demographic Data Processing Consent Withdrawal",
      "content": "To withdraw your consent to Aquent's processing of the demographic data we hold on you, we ask candidates, former employees, and current employees to complete the webform <a id='deleteEeocLink' href='https://aquent-privacy.my.onetrust.com/webform/05f24bb5-a0c4-43d4-966e-05606d5be9ca/c9104592-2b93-4008-a446-63b139fdf641'>here</a> or call us at +44(0)207 299 0202.",
      "button-text": "Close"
    },
    "details": "details",
    "disability-details": {
      "_list": "This list includes but is not limited to:",
      "deafness": "Deafness",
      "blindness": "Blindness",
      "diabetes": "Diabetes",
      "cancer": "Cancer",
      "epilepsy": "Epilepsy",
      "intellectual disabilities": "Intellectual disabilities",
      "partial or completely missing limbs": "Partial or completely missing limbs",
      "mobility impairments requiring the use of a wheel chair": "Mobility impairments requiring the use of a wheel chair",
      "autism": "Autism",
      "cerebral palsy": "Cerebral Palsy",
      "hiv infection": "HIV infection",
      "multiple sclerosis": "Multiple sclerosis",
      "muscular dystrophy": "Muscular dystrophy",
      "major depressive disorder": "Major depressive disorder",
      "bipolar disorder": "Bipolar disorder",
      "post-traumatic stress disorder": "Post-traumatic stress disorder",
      "obsessive-compulsive disorder": "Obsessive-compulsive disorder",
      "schizophrenia": "Schizophrenia"
    },
    "disability-no": "No",
    "disability-yes": "Yes",
    "do-not-wish-to-answer": "I do not wish to answer",
    "error": "{{fieldName}} is a required field.  Select “I do not wish to answer” if you do not want to disclose this information.",
    "error-immigration": "Immigration and employment authorization information is required.  Please select an answer.",
    "ethnicity": "Ethnicity",
    "ethnicity_other": "Other",
    "ethnicity-details": {
      "white": "White (not Hispanic or Latino) – A person having origins in any of the original peoples of Europe, North Africa, or the Middle East.",
      "black": "Black or African American (not Hispanic or Latino) – A person having origins in any of the black racial groups of Africa.",
      "hispanic": "Hispanic or Latino – A person of Mexican, Puerto Rican, Cuban, Central or South American, or other Spanish culture or origin, regardless of race.",
      "asian": "Asian (not Hispanic or Latino) – A person having origins in any of the original peoples of the Far East, Southeast Asian, or the Indian subcontinent including for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam.",
      "american-indian": "American Indian/Alaskan Native (not Hispanic or Latino) – A person having origins in any of the original peoples of North America and South America (including Central America), and who maintains tribal affiliation or community attachment.",
      "native-hawaiian": "Native Hawaiian or Other Pacific Islander (not Hispanic or Latino) – A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands.",
      "two-plus-races": "Two or More Races (not Hispanic or Latino) – All persons who identify with more than one of the above six races."
    },
    "equal-opportunity-header": "DEMOGRAPHIC DATA",
    "equal-opportunity-subtext": "Sharing the information requested below is entirely voluntary.  If you would prefer not to fill out this form, you can leave all fields blank and click submit.",
    "gender": "Gender Identity",
    "gender_other": "Other",
    "immigration-header": "IMMIGRATION AND EMPLOYMENT AUTHORIZATION INFORMATION",
    "immigration-subtext": "Lorem ipsum dolor sit amet, consectetur adipiscing elitctetur adipiscing elitctetur adipiscing elit.",
    "fostering-a-diverse": "We Are Committed to Fostering a Diverse and Inclusive Community of Talent",
    "fostering-a-diverse-subtext": " Please update your equal opportunity employment data below.",
    "lgbtq": "Do you identify as a member of the LGBTQIA+ community?",
    "lgbtq-details": {
      "details": "LGBTQIA+ stands for lesbian, gay, bisexual, transgender, and queer or questioning, with the + referring to a wider variety of gender, romantic, and sexual identities not limited to those spelled out in the acronym."
    },
    "neurodivergent": "Do you identify as Neurodivergent?",
    "neurodivergent-details": {
      "details1": "Neurodivergent means having a brain that functions differently in ways that interpret and work with information.",
      "details2": "Some examples include but are not limited to ADHD, autism, dyslexia, dyscalculia."
    },
    "newly-separated-vet": "Newly (Recently) Separated Veteran",
    "not-a-vet": "I am not a veteran",
    "other-protected-vet": "Other Protected Veteran",
    "require-sponsorship": "Do you now, or will you at any point in the future, require immigration related sponsorship?",
    "special-disabled-vet": "Special Disabled Veteran",
    "self-identification-disability": "Do you consider yourself to have a disability or health condition that inhibits your working capacity?",
    "success-find-jobs": "Find Jobs",
    "success-find-jobs-info": "Find other job opportunities",
    "success-header": "THANK YOU FOR SHARING YOUR DIVERSITY AND INCLUSION DATA",
    "success-learn-more": "Learn More",
    "success-learn-more-info": "Learn more about our diversity and inclusion initiatives",
    "success-update-profile": "Update Profile",
    "success-update-profile-info": "Update your Aquent profile",
    "thanks": "{{name}}, thank you for sharing your equal employment information!",
    "using-data": {
      "header": "HOW WE’RE USING THIS DATA",
      "subtext": "Aquent is collecting this data in support of our diversity and inclusion efforts.  We will use this data to evaluate our ability to recruit diverse candidates and to help our clients evaluate their hiring process. While you have the option not to answer the following question, we value any information you are comfortable sharing.\n\nAll candidates submitted to clients are submitted based on how well their skills and experience meet the job requirements. Clients may be provided reporting of aggregated data to help them understand the composition of the candidate pools submitted to them by Aquent, and to assist clients to evaluate their hiring process. Personally identifiable demographic data is not shared with them.\n\nAccess to demographic data is limited to only those with a need to access for the above described purpose. Demographic data will not be seen by anyone involved in the selection process.\n\nBy completing this form you confirm your consent to our processing of this data as described in this notice.  You may withdraw your consent by contacting <a id='privacyEmail' href='mailto:privacy@aquent.com'>privacy@aquent.com</a>, and you may update your information in your MyAquent Talent account.  Your information will be treated as strictly confidential and handled in compliance with <a id='privacyLink' target='_blank' href='https://aquent.co.uk/privacy-policy/'>Aquent's Privacy Policy</a> and the General Data Protection Regulations (GDPR) 2018."
    },
    "veteran-details": {
      "disabled-vet": "A \"disabled veteran\" is one of the following:\na veteran of the U.S. military, ground, naval or air service who is entitled to compensation (or who but for the receipt of military retired pay would be entitled to compensation) under laws administered by the Secretary of Veterans Affairs; or\na person who was discharged or released from active duty because of a service-connected disability.",
      "medal-veteran": "An \"Armed forces service medal veteran\" means a veteran who, while serving on active duty in the U.S. military, ground, naval or air service, participated in a United States military operation for which an Armed Forces service medal was awarded pursuant to Executive Order 12985.",
      "separated-vet": "A \"recently separated veteran\" means any veteran during the three-year period beginning on the date of such veteran's discharge or release from active duty in the U.S. military, ground, naval, or air service.",
      "vietnam-vet": "A \"Vietnam Era Veteran\" is a person who (a) served on active duty for a period of more than 180 days any part of which occurred between August 5, 1964 and May 7, 1975 and was discharged or released therefrom with other than a dishonorable discharge, or (b) was discharged or released from active duty for a service-connected disability if any part of such active duty was performed between August 5, 1964 and May 7, 1975, and (2) who was discharged or released within 48 months preceding the alleged violation of the Act, the affirmative action clause and/or the regulations issued pursuant to the Act.",
      "wartime-vet": "An “active duty wartime or campaign badge veteran” means a veteran who served on active duty in the U.S. military, ground, naval or air service during a war, or in a campaign or expedition for which a campaign badge has been authorized under the laws administered by the Department of Defense."
    },
    "veteran-status": "Veteran Status",
    "vietnam-vet": "Vietnam Era Veteran"
  },
  "footer": {
    "application-support": "Application Accommodation Support",
    "copyright-aq": "© {{year}} Aquent",
    "privacy-policy": "Privacy Policy",
    "questions-email": "questions@aquent.com"
  },
  "no": "No",
  "submit": "Submit",
  "delete": "Delete",
  "yes": "Yes",
  "gather": {
    "footer-address": "501 Boylston Street, 3rd Floor, Boston, MA 02116"
  }
}
